import React from 'react';
import {Icon} from '@vidazoo/ui-kit';
import {ReactComponent as DashboardsIcon} from './assets/dashboard-2.svg';
import {ReactComponent as ChartsIcon} from './assets/dashboard.svg';
import {ReactComponent as ReportingIcon} from './assets/reporting.svg';
import {ReactComponent as HistoryIcon} from './assets/history.svg';

// Preserve the legacy SVG paths: the icon font rasterizes their edges differently.
const icons = {
    'icon-dashboard-2': DashboardsIcon,
    'icon-dashboard': ChartsIcon,
    'icon-reporting': ReportingIcon,
    'icon-history': HistoryIcon,
};

export default function NavigationIcon({iconName, style}: {iconName: string; style?: React.CSSProperties}) {
    const SvgIcon = icons[iconName] as typeof ReportingIcon | undefined;
    if (!SvgIcon) return <Icon iconName={iconName} size={2} iconColor="white" style={style}/>;

    return <SvgIcon data-icon="true" aria-hidden="true" focusable="false"
        style={{width: '2rem', height: '2rem', flexShrink: 0, color: 'white', ...style}}/>;
}
